import { render, staticRenderFns } from "./AttachmentListDropdown.vue?vue&type=template&id=320ee7a0"
import script from "./AttachmentListDropdown.vue?vue&type=script&lang=js"
export * from "./AttachmentListDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports